import React, { Component } from "react";
import "styled-components/macro";

import iconSun from "./images/icon-sun.svg";
import iconEyedropper from "./images/icon-eyedropper.svg";
import iconEyedropperBlackbg from "./images/eye-dropper-blackbg.svg";
import iconEyedropperInk from "./images/icon-eyedropper-ink.svg";
import iconTBaskerville from "./images/icon-t-baskerville.svg";

export default class BonusFeaturesTilePersonalizedUI extends Component {
  initialState = {
    animationStep: 0,
  };
  state = this.initialState;
  timers = [];
  animationMs = 500;
  elasticCubicBezier = "cubic-bezier(0.25, 0.4, 0.55, 1.4)";
  render() {
    const { animationStep } = this.state;
    return (
      <div
        onMouseEnter={this.startAnimation}
        onMouseLeave={this.resetAnimation}
        css={`
          display: inline-flex;
          margin: 16px 0 0;
          width: 99.85%;
          height: 500px;
          color: white;
          cursor: grab;
          border-radius: 15.0px;
          overflow: hidden;
          background-color: hsl(240 11% 95% / 1);
          box-shadow: 2.5px 2.2px 0px 0.5px hsl(240deg 8% 90%);
          border: 1px solid hsl(0deg 0% 54% / 40%);
          filter: brightness(1.07);
          transition: filter 140ms ease-out;
          &:hover {
            box-shadow: none;
            filter: brightness(1);
          }
        `}
      >
        <div
          css={`
            display: flex;
            width: 100%;
          `}
        >
          <div
            css={`
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 50%;
            `}
          >
            <div
              css={`
                padding: 39px 0 0 39px;
                font-weight: 600;
                font-size: 14px;
                color: hsl(240 50% 55% / 1);
              `}
            >
              THEMING+MODS
            </div>
            <div
              css={`
                margin-top: 190px;
                font-size: 24px;
                line-height: 122%;
                padding: 39px;
              `}
            >
              <div
                css={`
                  font-size: 21px;
                  color: hsl(240 10% 35% / 1);
                `}
              >
                <strong>Fully-Control the Aesthetics</strong>
              </div>
              <div
                css={`
                  line-height: 133.5%;
                  font-size: 18px;
                  color: hsl(240 10% 60% / 1);
                `}
              >
                CoreText concerns itself with manipulating RSS data. The look
                & feel are yours to control. Change the text size, columns,
                themes and more using keyboard shortcuts.
              </div>
            </div>
          </div>

          {/* Animated content! */}
          <div
            css={`
              position: relative;
              width: 50%;
            `}
          >
            <div
              css={`
                position: relative;
              `}
            >
              <div
                css={`
                  position: absolute;
                  top: 200px;
                  right: -18px;
                  width: 480px;
                  height: 250px;
                  background: #5858d3;
                  filter: ${this.calcFilterBlueBlock()};
                  transition: ${this.calcTransitionBlueBlock()};
                `}
              >
                <div
                  css={`
                    position: absolute;
                    top: 0;
                    right: 0px;
                    width: 480px;
                    height: 125px;
                    background: #5858d3;
                    transform: ${this.calcTransformBlueExtenderTop()};
                    transition: transform ${this.animationMs / 2}ms
                      ${this.elasticCubicBezier};
                  `}
                />
                <div
                  css={`
                    position: absolute;
                    bottom: 0;
                    right: 0px;
                    width: 480px;
                    height: 125px;
                    background: #5858d3;
                    transform: ${this.calcTransformBlueExtenderBottom()};
                    transition: transform ${this.animationMs / 2}ms
                      ${this.elasticCubicBezier};
                  `}
                />
              </div>
              <img
                src={iconTBaskerville}
                alt="icon-t-baskerville"
                css={`
                  position: absolute;
                  top: 245px;
                  left: 230px;
                  width: 150px;
                  transform: ${this.calcTransformTBaskerville()};
                  transition: transform ${this.animationMs / 2}ms
                    ${this.elasticCubicBezier};
                `}
              />
            </div>
            {/* sun */}
            <div
              css={`
                position: absolute;
              `}
            >
              <img
                src={iconSun}
                css={`
                  position: relative;
                  top: 29px;
                  left: -67px;
                  width: 300px;
                  height: 300px;
                  filter: invert(${animationStep !== 12 ? 0 : 0.4})
                    brightness(0.75);
                  transition: filter ${this.animationMs * 0.6}ms ease-out;
                `}
                alt="sun-icon"
              />
            </div>

            {/* eyedropper */}
            <div
              css={`
                position: absolute;
                top: 40px;
                right: 210px;
              `}
            >
              <img
                src={iconEyedropper}
                alt="eyedropper"
                css={`
                  z-index: 1;
                  position: absolute;
                  top: -6px;
                  width: 135px;
                  filter: invert(0.65) brightness(1);
                  transition: filter ${this.animationMs * 0.6}ms ease-out;
                `}
              />
              <img
                src={iconEyedropperBlackbg}
                alt="iconEyedropperBlackbg"
                css={`
                  display: none;
                  z-index: 0;
                  position: absolute;
                  top: 62px;
                `}
              />
              <img
                src={iconEyedropperInk}
                alt="eyedropper-ink"
                css={`
                  position: absolute;
                  top: 152px;
                  left: 6px;
                  width: 55px;
                  filter: ${this.calcFilterEyedropperInk()};
                  transition: ${this.calcTransitionEyedropperInk()};
                `}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  startAnimation = () => {
    this.timers[1] = setTimeout(() => {
      //eyedropper suck out color from blue block
      this.setState({ animationStep: 1 });
      this.timers[2] = setTimeout(() => {
        // hue rotate eyedropper ink
        this.setState({ animationStep: 2 });
        this.timers[3] = setTimeout(() => {
          // hue rotate back eyedropper ink
          this.setState({ animationStep: 3 });
          this.timers[4] = setTimeout(() => {
            // inject color from eyedropper into blue block, and hue rotate blue block
            this.setState({ animationStep: 4 });
            this.timers[5] = setTimeout(() => {
              // rotate hue back blue block
              this.setState({ animationStep: 5 });
              this.timers[6] = setTimeout(() => {
                // increase text size (1st time)
                this.setState({ animationStep: 6 });
                this.timers[7] = setTimeout(() => {
                  // increase text size (2nd time)
                  this.setState({ animationStep: 7 });
                  this.timers[8] = setTimeout(() => {
                    // increase text size (3rd time)
                    this.setState({ animationStep: 8 });
                    this.timers[9] = setTimeout(() => {
                      // decrease text size (1st time)
                      this.setState({ animationStep: 9 });
                      this.timers[10] = setTimeout(() => {
                        // decrease text size (2nd time)
                        this.setState({ animationStep: 10 });
                        this.timers[11] = setTimeout(() => {
                          // decrease text size (3rd time)
                          this.setState({ animationStep: 11 });
                          this.timers[12] = setTimeout(() => {
                            // switch to light mode
                            this.setState({ animationStep: 12 });
                            // setTimeout(() => {
                            //   this.setState({ animationStep: 0 });
                            // }, this.animationMs * 3);
                          }, this.animationMs);
                        }, this.animationMs * 0.8);
                      }, this.animationMs);
                    }, this.animationMs * 2);
                  }, this.animationMs * 0.5);
                }, this.animationMs);
              }, this.animationMs * 2);
            }, this.animationMs * 6);
          }, this.animationMs * 4);
        }, this.animationMs * 3);
      }, this.animationMs);
    }, this.animationMs * 0.25);
  };

  resetAnimation = () => {
    this.timers.forEach((timer) => {
      clearTimeout(timer);
    });
    this.setState(this.initialState);
  };

  calcFilterEyedropperInk = () => {
    const { animationStep } = this.state;
    const filterStandard =
      "saturate(1) brightness(1) hue-rotate(359deg) invert(0)";

    if (animationStep === 0 || animationStep === 1)
    {
      return filterStandard;
    } else if (animationStep === 2)
    {
      return "saturate(0.5) brightness(2) hue-rotate(270deg)";
    } else if (animationStep === 3)
    {
      return "saturate(0.5) brightness(2) hue-rotate(0deg)";
    } else if (animationStep === 12)
    {
      return "saturate(1) brightness(1) hue-rotate(0deg) invert(0) opacity(0)";
    } else if (animationStep >= 4)
    {
      return "saturate(0) brightness(1) hue-rotate(0deg) invert(0) opacity(0)";
    }
  };
  calcTransitionEyedropperInk = () => {
    const { animationStep } = this.state;
    if ([2, 3].includes(animationStep))
    {
      return `filter ${this.animationMs * 3}ms ease-out`;
    } else return `filter ${this.animationMs}ms ease-out`;
  };
  calcFilterBlueBlock = () => {
    const { animationStep } = this.state;

    if (animationStep === 0)
    {
      return "saturate(0) brightness(1.4) hue-rotate(359deg)";
    } else if ([1, 2, 3].includes(animationStep))
    {
      return "saturate(0) brightness(1.7) hue-rotate(359deg)";
    } else if (animationStep === 4)
    {
      return "saturate(1) brightness(1) hue-rotate(90deg)";
    } else if (animationStep === 12)
    {
      return "saturate(1) brightness(0.25) hue-rotate(0deg)";
    } else return "saturate(1) brightness(1) hue-rotate(0deg)";
  };

  calcTransitionBlueBlock = () => {
    const { animationStep } = this.state;
    if (animationStep === 4)
    {
      return `filter ${this.animationMs * 6}ms ease-out`;
    } else return `filter ${this.animationMs * 3}ms ease-out`;
  };

  calcTransformTBaskerville = () => {
    const { animationStep } = this.state;
    if ([6, 10].includes(animationStep))
    {
      return "scale(1.1)";
    } else if ([7, 9].includes(animationStep))
    {
      return "scale(1.2)";
    } else if (animationStep === 8)
    {
      return "scale(1.3)";
    } else return "scale(1.0)";
  };

  calcTransformBlueExtenderTop = () => {
    const { animationStep } = this.state;

    if ([6, 10].includes(animationStep))
    {
      return "translateY(-10px)";
    } else if ([7, 9].includes(animationStep))
    {
      return "translateY(-20px)";
    } else if (animationStep === 8)
    {
      return "translateY(-30px)";
    } else return "translateY(0px)";
  };
  calcTransformBlueExtenderBottom = () => {
    const { animationStep } = this.state;

    if ([6, 10].includes(animationStep))
    {
      return "translateY(10px)";
    } else if ([7, 9].includes(animationStep))
    {
      return "translateY(20px)";
    } else if (animationStep === 8)
    {
      return "translateY(30px)";
    } else return "translateY(0px)";
  };
}
